import { render, staticRenderFns } from "./MenubarGoals.vue?vue&type=template&id=cf3b69ca&"
import script from "./MenubarGoals.vue?vue&type=script&lang=js&"
export * from "./MenubarGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports